/*
 * @Author: songpan
 * @Date: 2022-03-03 15:53:14
 * @LastEditTime: 2022-09-23 10:35:05
 * @LastEditors: songpan
 * @Description: axios封装
 */

import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
// import { getRequestHeaders } from '@/api/sign';

export interface ResponseWrapper<T> {
  msg: string;
  code: number;
  data: T;
  message: string;
}

// const URL = process.env.deploy_env === 'prd' ? 'https://gw-jhb.sanygroup.com' : 'https://gw-jhbtest.sanygroup.com';
const service = axios.create({
  // baseURL: URL, // api base_url
  timeout: 20000, // 请求超时时间
});
// 接口发生业务异常时（code != 200）统一错误Error对象，页面需要异常信息时可直接拿error.message，也可以拿code码和response信息
export class DZRespError<T> extends Error {
  code: number;
  response: T;

  constructor(code: number, msg: string, response: T) {
    console.log(msg);
    super(msg);
    this.code = code;
    this.response = response;
  }
}

const err = (error: AxiosError) => {
  if (error.response) {
    if (error.response.status !== 200) {
      console.log(error);
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

// request interceptor
service.interceptors.request.use((config) => {
  // const token = 'token'
  // if (config) {
  //   config.headers['Token'] = '' // 让每个请求携带自定义 token 请根据实际情况自行修改
  // }
  return config;
}, err);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// const headersFuns = (data: any) => {
//   service.interceptors.request.use((config) => {
//     if (config.headers) {
//       config.headers['sign'] = getRequestHeaders(data).sign;
//       config.headers['ts'] = getRequestHeaders(data).ts;
//     }
//     return config;
//   }, err);
// };
// response interceptor
service.interceptors.response.use((response) => {
  if (response.status !== 200) {
    return Promise.reject(
      //  统一Error对象，确保catch到的错误信息永远为Error对象
      new DZRespError<AxiosResponse>(response.data.code, response.data.msg || '接口错误', response)
    );
  }
  return response;
}, err);

export default {
  get<T>(url: string, params: unknown, config?: Omit<AxiosRequestConfig, 'params'>) {
    return service.get<ResponseWrapper<T>>(url, { ...config, params }).then(({ data }) => data);
  },
  post<T, D = unknown>(url: string, data: D, config?: AxiosRequestConfig) {
    return service
      .post<ResponseWrapper<T>, AxiosResponse<ResponseWrapper<T>, D>, D>(url, data, config)
      .then(({ data }) => data);
  },
  put<T, D = unknown>(url: string, data: D, config?: AxiosRequestConfig) {
    return service
      .put<ResponseWrapper<T>, AxiosResponse<ResponseWrapper<T>, D>, D>(url, data, config)
      .then(({ data }) => data);
  },
  request: service.request,
};
